<ngx-spinner bdColor="rgba(51,51,51,0.8)" size="medium" color="#fff" loadingText="Loading..." type="ball-scale-multiple">
</ngx-spinner>
<app-header></app-header>
<section class="supplier_fuso_tabs mar-top-20">
  <ul class="nav nav-tabs" role="tablist">
    <li class="nav-item">
      <a class="nav-link active" data-toggle="tab" href="#unlisted" role="tab" #unlistNav>{{'Unlisted Supplier Code' |
        translate}}</a>
    </li>
    <li class="nav-item">
      <a class="nav-link" data-toggle="tab" href="#suppCode" role="tab" #createNav>{{'Create New Supplier Code' |
        translate}}</a>
    </li>
  </ul>
 
  <div class="tab-content">
    <div class="tab-pane active" id="unlisted" #unlistPane>
      <section class="part_search_bar">
        <div class="col-md-6 offset-md-3 search input-group">
          <input placeholder="{{'Search by Supplier Code' | translate}}" [(ngModel)]="srchValue"
            class="form-control" />
          <span class="input-group-btn">
            <button class="btn btn-light" type="button" (click)="onChangeTable(config)">
              {{'Search' | translate}}
            </button>
          </span>
        </div>
      </section>
      <section class="parts_container pad-top-40">
        <div class="row mar-btm-40">
          <div class="col-md-6">
            <!-- <pagination *ngIf="config.paging" class="pagination-sm pull-right pad-top-10" [(ngModel)]="page"
              [totalItems]="length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
              (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
            </pagination>
            <ng-table [config]="config" (tableChanged)="onChangeTable(config)" (cellClicked)="navigateTab($event)"
              [rows]="rows" [columns]="columns">
            </ng-table> -->

            
            <pagination *ngIf="config.paging" class="pad-top-10" [(ngModel)]="page"
              [totalItems]="length" [itemsPerPage]="itemsPerPage" [maxSize]="maxSize" [boundaryLinks]="true" [rotate]="false"
              (pageChanged)="onChangeTable(config, $event)" (numPages)="numPages = $event">
            </pagination>
            <div class="example-container mat-elevation-z8">
            
              <mat-table [dataSource]="dataSource" matSort>
            
                <!-- ID Column -->
                <ng-container matColumnDef="supplierCode">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Supplier Code </mat-header-cell>
                  <mat-cell *matCellDef="let row"> {{row.supplierCode}} </mat-cell>
                </ng-container>
            
                <!-- Progress Column -->
                <ng-container matColumnDef="unlisted">
                  <mat-header-cell *matHeaderCellDef mat-sort-header> Unlisted </mat-header-cell>
                  <mat-cell *matCellDef="let row"> <div class="text-center hasLink" (click)="navigateTab(row.supplierCode)">Click to Add Supplier Code</div> </mat-cell>
                </ng-container>


                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;">
                </mat-row>

              </mat-table>
             
          </div>
            
        </div>
        </div>
      </section>
    </div>

    <div class="tab-pane" id="suppCode" #createPane>
      <section class="part_search_bar"></section>
      <section class="createSuppCodeWrap pad-btm-30">
        <div class="row_title pad-btm-30">{{'Create Supplier Code' | translate}}</div>
        <form #f="ngForm" (ngSubmit)="f.form.valid && addSupplierCode(f)" novalidate>
          <div class="row ">
            <div class="col-md-4">
              <div class="form-group row" [ngClass]="{'has-error': supplierCode.invalid && f.submitted}">
                <label for="firstName" class="col-sm-6 col-form-label">{{'SUPPLIERCODE' | translate}}:
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" name="supplierCode" [(ngModel)]="newSupplierCode"
                    (ngModelChange)="valuechange($event)" #supplierCode="ngModel" required />
                  <div [hidden]="supplierCode.valid || (supplierCode.pristine && !f.submitted)" class="required-error">
                    {{'Supplier Code is Required' | translate}}
                  </div>
                  <div id="mytext" class="required-error"></div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row" [ngClass]="{'has-error': contractType.invalid && f.submitted}">
                <label for="firstName" class="col-sm-6 col-form-label">{{'Paid By' | translate}}:
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <select class="form-control" name="contractType" [(ngModel)]="contract" #contractType="ngModel"
                    required>
                    <option value="">{{'Select' | translate}}</option>
                    <option *ngFor="let opt of paidOpt" [value]="opt">{{opt}}</option>
                  </select>
                  <div [hidden]="contractType.valid || (contractType.pristine && !f.submitted)" class="required-error">
                    {{'Paid by is Required' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row" [ngClass]="{'has-error': locationType.invalid && f.submitted}">
                <label for="firstName" class="col-sm-5 col-form-label">{{'Supplier Type' | translate}}:
                  <span class="required">*</span>
                </label>
                <div class="col-sm-5">
                  <select class="form-control" name="locationType" [(ngModel)]="type" #locationType="ngModel" required>
                    <option value="" selected>{{'Select' | translate}}</option>
                    <option *ngFor="let opt of locationOpt" [value]="opt">{{opt}}</option>
                  </select>
                  <div [hidden]="locationType.valid || (locationType.pristine && !f.submitted)" class="required-error">
                    {{'Supplier type is Required' | translate}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-4">
              <div class="form-group row" [ngClass]="{'has-error': supplierNameEng.invalid && f.submitted}">
                <label for="firstName" class="col-sm-6 col-form-label">{{'SUPPNAME[Eng]' | translate}}:
                  <span class="required">*</span>
                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" name="supplierNameEng" [(ngModel)]="suppNameEng"
                    #supplierNameEng="ngModel" required />
                  <div [hidden]="supplierNameEng.valid || (supplierNameEng.pristine && !f.submitted)" class="required-error">
                    {{'Supplier Name is Required' | translate}}
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-4">
              <div class="form-group row">
                <label for="firstName" class="col-sm-6 col-form-label">{{'SUPPNAME[Jap]' | translate}}:

                </label>
                <div class="col-sm-6">
                  <input type="text" class="form-control" name="supplierNameJap" [(ngModel)]="suppNameJap" />
                </div>
              </div>
            </div>
            <div class="col-md-4">

            </div>
            <br>
            <div class="col-md-4" style="margin-left: 40%; margin-top: 2rem;">
              <button type="submit" [disabled]="userIDTaken" class="btn btn-dark">{{'Add Supplier Code' | translate}}</button>
            </div>
          </div>
        </form>
      </section>
      <section class="parts_container pad-top-40">
        <div class="row_title pad-btm-30">{{'Existing Supplier Code' | translate}}</div>
        
        <div class="row">
          <div class="col-md-12 text-right pad-btm-30"><button class="btn btn-dark" (click)="openExport(exportConfirm)">{{'Export Supplier Code' | translate}}</button>
          </div>
        </div>
        <br>
        <div class="row">
          <div class="col-md-12 mar-btm-30">
            <table datatable class="text-center" [dtOptions]="dtOptions[0]" [dtTrigger]="dtTrigger" class="table table-white table-bordered table-striped">
              <thead>
                <tr>
                  <th class="text-center">{{'SUPPLIERCODE' | translate}}</th>
                  <th class="text-center">{{'SUPPNAME[Eng]' | translate}}</th>
                  <th class="text-center">{{'SUPPNAME[Jap]' | translate}}</th>
                  <th class="text-center">{{'Paid By' | translate}}</th>
                  <th class="text-center">{{'Supplier Type' | translate}}</th>
                  <th class="text-center">{{'Users are registered' | translate}}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of supplierCodeList">
                  <td class="text-center hasLink">
                    <a (click)="editRowDetails(editDetails,data)">{{data.supplierCode}}</a>
                  </td>
                  <td class="text-center">{{data.supplierNameEN}}</td>
                  <td class="text-center">{{data.supplierNameJP}}</td>
                  <td class="text-center">{{data.contract}}</td>
                  <td class="text-center">{{data.supplierClassification}}</td>
                  <td class="text-center" *ngIf="data.loginId != null">Yes</td>
                  <td class="text-center" *ngIf="data.loginId == null">No</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        
      </section>

      <ng-template #editDetails let-c="close" let-d="dismiss">
        <div class="modal-header">
          <h4 class="modal-title">{{'Edit Details' | translate}}</h4>
          <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <label for="supplierCode" class="col-form-label">{{'SUPPLIERCODE' | translate}}:</label>
          <input type="text" class="form-control" name="supplierCode" [(ngModel)]="newSupplierCodeEdit" disabled />
          <label for="supplierNameEng" class="col-form-label">{{'SUPPNAME[Eng]' | translate}}:</label>
          <input type="text" class="form-control" name="supplierNameEng" [(ngModel)]="suppNameEngEdit" (ngModelChange)="suppNameEngEditChange($event)"
            required />
          <span class="help-block" id="EN"></span>
          <br>
          <label for="supplierNameJap" class="col-form-label">{{'SUPPNAME[Jap]' | translate}}:</label>
          <input type="text" class="form-control" name="supplierNameJap" [(ngModel)]="suppNameJapEdit" (ngModelChange)="suppNameJpEditChange($event)"
            required />
          <span class="help-block" id="JP"></span>
          <br>
          <!-- <div *ngIf=" !suppNameJapEdit.valid" class="help-block">Supplier Name is required</div> -->
          <label for="contract" class="col-form-label">{{'Paid By' | translate}}:</label>
          <select class="form-control" name="contract" [(ngModel)]="contractEdit">
            <!-- <option value=''>Select</option> -->
            <option *ngFor="let opt of paidOpt" [value]="opt">{{opt}}</option>
          </select>
          <label for="type" class="col-form-label">{{'Supplier Type' | translate}}:</label>
          <select class="form-control" name="type" [(ngModel)]="supplierTypeEdit">
            <!-- <option value=''>Select</option> -->
            <option *ngFor="let opt of locationOpt" [value]="opt">{{opt}}</option>
          </select>
        </div>
        <div class="modal-footer">
          <button type="button" class="col-md-2  btn btn-dark" (click)="saveChanges()">{{'Save' | translate}}</button>
          <button type="button" class="col-md-2 btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' |
            translate}}</button>
        </div>
      </ng-template>
    </div>
  </div>
</section>


<!--Supplier code creation confirmation Modal -->

<ng-template #addSuppCode let-c="close" let-d="dismiss">
  <div class="modal-header">
    <!-- <h4 class="modal-title">Success</h4>
    <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button> -->
  </div>
  <div class="modal-body">
    <p>Do you need to add new supplier code?</p>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn btn-dark" (click)="addSupplierCode()">Ok</button>
    <button type="button" class="btn btn-outline-dark" (click)="c('Close click')">Cancel</button>
  </div>
</ng-template>

<ng-template #exportConfirm let-c="close" let-d="dismiss">
  <!-- <div class="modal-header">
        <h4 class="modal-title">{{'Edit Details' | translate}}</h4>
        <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
          <span aria-hidden="true">&times;</span>
        </button>
      </div> -->
  <div class="modal-body">
    {{'Are you sure you want to export supplier codes?' | translate }}
  </div>
  <div class="modal-footer">
    <button type="button" class="col-md-2  btn btn-dark" (click)="exportCSV()">Export </button>
    <button type="button" class="col-md-2 btn btn-outline-dark" (click)="c('Close click')">{{'CANCEL' | translate}}</button>
  </div>
</ng-template>